import { Icon } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
import './TickIcon.scss';
const TickIcon = ({ value }) => (value
    ? React.createElement("div", { className: "green" },
        React.createElement(Icon, { iconName: "check" }))
    : React.createElement("div", { className: "red" },
        React.createElement(Icon, { iconName: "block" })));
export default TickIcon;
